import { AppComponent } from 'src/app/app.component';
import { Component, OnInit, Input, ElementRef, ViewEncapsulation, Inject, ChangeDetectionStrategy } from '@angular/core';

import { AuthService } from '../../pages/auth/auth.service';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-role-access',
  templateUrl: './role-access.component.html',
  styleUrls: ['./role-access.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class RoleAccessComponent implements OnInit {
  public isBlockedAccess;
  public roleElement;

  @Input() action;
  @Input() permission;
  @Input() placement;
  @Input() message;

  constructor(
    private authService: AuthService,
    private el: ElementRef,
    @Inject(AppComponent) private appComp: AppComponent
  ) {}

  ngOnInit() {
    this.placement = this.placement || 'bottom';
    this.message = this.message || 'У вас нет доступа для использования данной функции';

    this.authService.subscribeAuthData().subscribe((authData) => {
      this.checkBlockedAccess(authData.permissions);
    });
  }

  public handleMouseEvent() {
    this.appComp.update();
  }

  public checkBlockedAccess(permissions) {
    if (permissions === null) {
      return;
    }
    this.isBlockedAccess = permissions.indexOf(this.permission) === -1;

    setTimeout(() => {
      this.roleElement = this.el.nativeElement.querySelector('[data-role-element]');
      this.changeStateElement();
    });
  }

  public changeStateElement() {
    if (this.isBlockedAccess) {
      switch (this.action) {
        case 'disable':
          if (this.roleElement) {
            this.roleElement.setAttribute('disabled', true);
          }
          return;
        case 'visible':
          // this.roleElement.setAttribute('hidden', true);
          return;
        default:
          return;
      }
    }
  }
}
